import {
  SET_REPORTS,
  SET_BATCH_TYPES,
  SET_POST_BATCHES,
  SET_SELECTED_BATCHES,
  SET_POST_BATCH_PAYMENTS,
  SET_TOTALS_VALID,
} from './PostPaymentReducer'
import { ADD_PDF_TO_LIST, pdfTypes } from '../../ReportViewer/ReportViewerReducer'
import * as api from '../../../requests'

export const GetAndSetReports = () => {
  return (dispatch) => {
    api.GET_POST_PAYMENT_REPORT_DEF(
      (response) => dispatch({ type: SET_REPORTS, reports: response }),
      (err) => {
        console.error(err)
      }
    )
  }
}

export const GetAndSetBatchTypes = () => {
  return (dispatch) => {
    dispatch({ type: SET_BATCH_TYPES, batchTypes: [{ id: 0, label: 'Payment' }] })
  }
}

export const GetAndSetBatches = (type, throughDate) => {
  return (dispatch) => {
    api.GET_POST_PAYMENT_BATCHES(
      type,
      throughDate.replaceAll('/', '-'),
      (response) => {
        dispatch({ type: SET_POST_BATCHES, batches: response })
      },
      (err) => {
        console.error(err)
      }
    )
  }
}

export const SetSelectedBatches = (selectedRows) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_BATCHES, selectedBatches: selectedRows })
  }
}

export const GetAndSetPayments = (batches, callback) => {
  return (dispatch) => {
    api.POST_TO_GET_PAYMENT_BATCHES_FOR_POST(
      batches,
      (response) => {
        dispatch(SetPayments(response))
        callback(true, 'success')
      },
      (err) => {
        callback(false, err.ExceptionMessage)
      }
    )
  }
}

export const SetPayments = (payments) => {
  return (dispatch) => {
    dispatch({ type: SET_POST_BATCH_PAYMENTS, payments: payments })
  }
}

export const UpdatePaymentTotals = (payments, totals) => {
  return (dispatch) => {
    for (let i = 0; i < totals.length; i++) {
      payments[i].amount = totals[i]
    }
    dispatch(SetPayments(payments))
  }
}

export const PostPaymentBatches = (payments, callback) => {
  return (dispatch) => {
    api.POST_PAYMENT_BATCHES(
      payments,
      (response) => {
        callback(response.sucessful, response.message, response.depositNum)
        dispatch({ type: SET_TOTALS_VALID, areTotalsValid: false })
      },
      (err) => {
        console.error(err)
        callback(false, err.Message)
      }
    )
    return false
  }
}

export const GetReports = (depositNum) => {
  return (dispatch) => {
    dispatch({
      type: ADD_PDF_TO_LIST,
      pdfInfo: {
        filename: `BatchReport_${depositNum}.pdf`,
        type: pdfTypes.BATCH_REPORT,
        depositNum: depositNum,
      },
    })
  }
}
